import {IPickerItem, ISearcher, ISearchPickerOptions, Utility} from "searchpicker";

export class StaticItemsSearcher implements ISearcher {

    constructor(private pickerItems: IPickerItem[]) {

    }

    search(query: string, options: ISearchPickerOptions,
           onresults: (items: IPickerItem[]) => void,
           onerror?: (message: string) => void): any {

      const foundItems = Utility.filterItems(this.pickerItems, query, options);
        onresults(foundItems);
    }

}
